const API_URL =
  process.env.NODE_ENV === "production"
    ? "/api" // En production, Apache fait le proxy vers Gunicorn
    : "http://localhost:8000/api"; // En dev, on pointe directement vers Gunicorn: 8082

export default API_URL;

/*
const API_URL = process.env.REACT_APP_API_URL || "/api";
export default API_URL;
*/
